






















import { Component, Prop, Watch } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import DataTable from '@/components/molecules/DataTable/DataTable.vue'
import { BibliographyLendCount, SystemCode } from '@/api'
import { orderBy } from 'lodash'
import { SortOrder } from '@/types'
import {
  Col,
  findSortColumnItem,
  setSortOrder,
  SortColumn
} from '@/components/molecules/DataTable'

// TODO 工事中
const COLS: Col[] = [
  {
    width: 50,
    items: [
      {
        name: 'no',
        align: 'right'
      }
    ]
  },
  {
    width: '20',
    resizable: true,
    items: [
      {
        name: 'collectionNo',
        headerText: '資料番号',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: '12',
    resizable: true,
    items: [
      {
        name: 'holdingBranchCode',
        headerText: '所蔵館',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: '12',
    resizable: true,
    items: [
      {
        name: 'status',
        headerText: '状態',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: '8',
    resizable: true,
    items: [
      {
        name: 'lendTotalCount',
        headerText: '累計',
        align: 'right',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: '8',
    resizable: true,
    items: [
      {
        name: 'lendCount0',
        headerText: '本年度',
        align: 'right',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: '8',
    resizable: true,
    items: [
      {
        name: 'lendCount1',
        headerText: '昨年度',
        align: 'right',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: '8',
    resizable: true,
    items: [
      {
        name: 'lendCount2',
        headerText: '2年前',
        align: 'right',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: '8',
    resizable: true,
    items: [
      {
        name: 'lendCount3',
        headerText: '3年前',
        align: 'right',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: '8',
    resizable: true,
    items: [
      {
        name: 'lendCount4',
        headerText: '4年前',
        align: 'right',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: '8',
    resizable: true,
    items: [
      {
        name: 'lendCount5',
        headerText: '5年前',
        align: 'right',
        sortable: true,
        sortOrder: ''
      }
    ]
  }
]

@Component({
  components: { DataTable }
})
export default class ConfirmationLendCountTable extends ComponentVue {
  @Prop({
    type: Array,
    required: true
  })
  items!: BibliographyLendCount[]

  @Prop({
    type: Number
  })
  height!: number

  @Prop({
    type: Boolean,
    default: false
  })
  isOpen!: boolean

  sortName: string = ''

  sortOrder: SortOrder = ''

  get cols(): Col[] {
    return COLS
  }

  get sortedItems(): BibliographyLendCount[] {
    if (this.sortName) {
      return orderBy<BibliographyLendCount>(
        this.items,
        (item: BibliographyLendCount) => {
          const propertyValue =
            item[this.sortName as keyof BibliographyLendCount]
          const type: string = Object.prototype.toString
            .call(propertyValue)
            .slice(8, -1)
            .toLowerCase()

          if (type === 'object') return (propertyValue as SystemCode).shortName

          return propertyValue
        },
        this.sortOrder as 'asc' | 'desc'[]
      )
    }

    return this.items
  }

  @Watch('isOpen')
  initialize(): void {
    this.onSort({
      name: '',
      order: ''
    })
  }

  onSort(sortColumn: SortColumn) {
    setSortOrder(this.cols, sortColumn)

    const sortColItem = findSortColumnItem(this.cols)

    this.sortName = sortColItem?.name ?? ''
    this.sortOrder = sortColItem?.sortOrder ?? ''
  }
}
